import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import promise from "redux-promise";
import createHistory from "history/createBrowserHistory";
import rootReducer from "./reducers";
import analyticsMiddleware from "./analyticsMiddleware";

import messages from "./static/messages";

// For dev
import { composeWithDevTools } from "redux-devtools-extension";

const logger = () => next => action => {
  // console.log("dispatching", action);
  let result = next(action);
  // console.log("next state", store.getState());
  return result;
};

export const history = createHistory({});

const getLocale = () => {
  return localStorage.getItem("locale") || "fi";
};

const lang = getLocale();

const initialState = {
  locale: {
    lang: lang, //localStorage.getItem('locale') || 'fi',
    messages: messages[lang]
  }
};

const enhancers = [];
const middleware = [
  analyticsMiddleware,
  logger,
  thunk,
  promise,
  routerMiddleware(history)
];

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(composedEnhancers)
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js